import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';
import countryCodes from './countries-dialcode-details';

import '../scss/components/_countrycode-field.scss';
import '../scss/components/_countrycode-flag.scss';
import getSelectedCountryInfo from './country-code-helper';

const countryCodeArray = Object.values(countryCodes);

export default function CountryCode({ selectedDialCode, selectedCountry, onDialCodeChange }) {
  const [countryCodeList, updateCountryCodeList] = useState(countryCodeArray);
  const selectedCountryInfo = getSelectedCountryInfo(selectedDialCode, selectedCountry);

  const selectCountry = (event) => {
    const { iso2: selectedISO, country: selectedCode } = event.currentTarget.dataset;
    const selectedCountryCodeInfo = countryCodeArray.find(({ iso2, code }) => (
      iso2 === selectedISO && code === selectedCode));
    onDialCodeChange(selectedCountryCodeInfo);
  };

  const onSearch = (event) => {
    let { value } = event.target;
    if (value && value.trim()) {
      value = value.startsWith('+') ? value.substring(1) : value;
      updateCountryCodeList(countryCodeArray
        .filter(({ name, iso2 }) => name.toLowerCase().startsWith(value.toLowerCase())
        || iso2.startsWith(value)));
    } else {
      updateCountryCodeList(countryCodeArray);
    }
  };

  return (
    <div className="g-drop-common g-dropdown-wrap top-pos has-search g-country-dropdown">
      <button className="g-drop-btn" data-testid="selectedCountryCode" tabIndex="-1">
        <i className={`flag-ele ${selectedCountryInfo.code && selectedCountryInfo.code.toLowerCase()}`} />
        <span>{`(+${selectedCountryInfo.iso2})`}</span>
        <i className="g-drop-arrow" />
      </button>
      <div className="g-dropmenu has-arrow align-left">
        <div className="g-searchbox ignore-click">
          <input data-testid="country-search" className="ignore-click" placeholder="Search in dropdown" onInput={onSearch} />
        </div>
        <ul>
          {!!countryCodeList.length && countryCodeList.map(({ code, iso2, name }) => (
            <li data-testid={`code-${code && code.toLowerCase()}`} className={(iso2 === selectedCountryInfo.iso2 && code === selectedCountryInfo.code) ? 'has-check selected' : 'has-check'} key={iso2} data-iso2={iso2} data-country={code} onClick={selectCountry}>
              <button className={(iso2 === selectedCountryInfo.iso2 && code === selectedCountryInfo.code) ? 'g-radio-button g-radio-selected' : 'g-radio-button'} />
              <i className={`flag-ele ${code && code.toLowerCase()}`} />
              <span>
                {`${name}  (+${iso2})`}
              </span>
            </li>
          ))}
          {!countryCodeList.length && <li data-testid="noResut" className="no-user-select"><span>No results found</span></li>}
        </ul>
      </div>
    </div>
  );
}

CountryCode.propTypes = {
  selectedDialCode: PropTypes.string.isRequired,
  onDialCodeChange: PropTypes.func.isRequired,
  selectedCountry: PropTypes.string.isRequired,
};
